export const commonReducerKey = "common";
export const commonInitialState = {
  features: [],
};
